import * as React from 'react';
import classnames from 'classnames';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import { useContactLensProductData } from '../../../../../context/product-context-hooks.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';
import '@grandvisionhq/common';
import { StickyMobileCtaAndPrice } from '../../../../StickyCta/StickyMobileCtaAndPrice.js';
import { LensesPerBoxText } from '../CLText/LensesPerBoxText/LensesPerBoxText.js';
import '@grandvisionhq/state';
import { ContactLensesCTA } from '../ContactLensesCTA/ContactLensesCTA.js';
import '../../../../../hooks/useCartDiscountsQuery/types.js';
import '@grandvisionhq/graphql';
import '../../../../../operations/queries/get-accessories-by-slug.js';
import '../../../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../../../operations/queries/get-frames-by-slug.js';
import '../../../../../operations/queries/get-solutions-by-slug.js';
import '../../../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../../../operations/queries/get-manufacturer-by-key.js';
import '@grandvisionhq/utils';
import '../../../../../hooks/use-product-view-history.js';
import '@grandvisionhq/frk-routing';
import '../../../../../types/product.js';
import '@swc/helpers';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/forms';
import '@grandvisionhq/analytics';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/inventory';
import '@grandvisionhq/lib-utils-html';
import '../../../../VTO/context/VtoProvider.js';
import 'usehooks-ts';
import 'use-onclickoutside';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-visuals';
import '../../../../../slots/context.js';
import '@grandvisionhq/content';
import '../../operations/queries/get-contact-lens-by-prescription.js';

const ContactLensesStickyCTA = ({ className  })=>{
    const { activeVariant  } = useContactLensProductData();
    const { lensesPerBox  } = activeVariant;
    return /*#__PURE__*/ React.createElement(StickyMobileCtaAndPrice, {
        className: classnames('contact-lenses-sticky-cta', className),
        cta: /*#__PURE__*/ React.createElement(ContactLensesCTA, {
            className: "contact-lenses-sticky-cta__button"
        }),
        priceSubtitle: /*#__PURE__*/ React.createElement(LensesPerBoxText, {
            lensesPerBox: lensesPerBox
        })
    });
};

export { ContactLensesStickyCTA };
//# sourceMappingURL=ContactLensesStickyCTA.js.map
